"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRoarApp = isRoarApp;
const roarFirebaseProjects = [
    'gse-yeatmanlab',
    'gse-roar-assessment',
    'gse-roar-assessment-staging',
    'gse-roar-assessment-dev',
    'gse-roar-admin',
    'gse-roar-admin-staging',
    'gse-roar-admin-dev',
];
function isRoarApp(_firekit) {
    var _a, _b, _c, _d;
    const projectId = (_d = (_c = (_b = (_a = _firekit === null || _firekit === void 0 ? void 0 : _firekit.firebaseProject) === null || _a === void 0 ? void 0 : _a.firebaseApp) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.projectId) !== null && _d !== void 0 ? _d : '';
    return roarFirebaseProjects.includes(projectId);
}
